import { Navbar, Footer } from './components';
import { Hero, About, Skills, Projects, Contact } from './sections';

/**
 * Tech Sierra Solutions - Main App Component
 * A modern, animated company portfolio landing page
 *
 * Built with:
 * - React 19 + TypeScript
 * - TailwindCSS + Glassmorphism
 * - Framer Motion animations
 * - Dark/Light mode support
 */
function App() {
  return (
    <div className="min-h-screen bg-white dark:bg-dark-900 transition-colors duration-300">
      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main>
        {/* Hero - Full viewport intro */}
        <Hero />

        {/* About - Personal bio & stats */}
        <About />

        {/* Skills - Technical expertise */}
        <Skills />

        {/* Projects - Portfolio showcase */}
        <Projects />

        {/* Contact - Get in touch form */}
        <Contact />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
